/**
 * Entity Base Types - URI-Based Reference System
 *
 * Every shareable entity in Humanizer has a stable URI for cross-referencing.
 * URI Patterns:
 * - persona://author/slug
 * - style://author/slug
 * - book://author/slug
 * - source://chatgpt/{conversationId}
 * - source://notebook/{pageId}
 * - source://file/{path}
 */
// ═══════════════════════════════════════════════════════════════════
// HELPER FUNCTIONS
// ═══════════════════════════════════════════════════════════════════
/**
 * Generate a URI for an entity
 */
export function generateURI(type, author, name) {
    const slug = name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
    const authorSlug = author
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
    return `${type}://${authorSlug}/${slug}`;
}
/**
 * Generate a source URI
 */
export function generateSourceURI(type, id) {
    return `source://${type}/${id}`;
}
/**
 * Parse a URI into its components
 */
export function parseURI(uri) {
    const match = uri.match(/^([^:]+):\/\/([^/]+)(?:\/(.+))?$/);
    if (!match)
        return null;
    const [, type, first, second] = match;
    // source://type/id has different structure
    if (type === 'source') {
        return { type: first, slug: second || first };
    }
    return {
        type,
        author: first,
        slug: second || first,
    };
}
/**
 * Check if a string is a valid entity URI
 */
export function isValidURI(uri) {
    return /^[a-z]+:\/\/[^/]+/.test(uri);
}
//# sourceMappingURL=entity.js.map